<template>
	<v-container>
		<div v-show="showFilters">
			<!-- Loading component -->
			<v-overlay :value="loadingDataGetServiceProvider ||
					loadingDataGetServiceProviderCity ||
					loadingDataGetServiceProviderAccommodationType ||
					loadingDataGetResellerPartner ||
					loadingDataGetResellerUser ||
					loadingDataGetArrivalBy ||
					loadingDataGetKantons ||
					loadingDataGetStatus ||
					loadingDataGetNationalitiesIso ||
					loadingDataGetNationalitiesHesta">
				<registration-report-progress-bar
					:showSpinner="loadingDataGetServiceProvider ||
					loadingDataGetServiceProviderCity ||
					loadingDataGetServiceProviderAccommodationType ||
					loadingDataGetResellerPartner ||
					loadingDataGetResellerUser ||
					loadingDataGetArrivalBy ||
					loadingDataGetKantons ||
					loadingDataGetStatus ||
					loadingDataGetNationalitiesIso ||
					loadingDataGetNationalitiesHesta"
				/>
			</v-overlay>
			<v-card>
			<v-alert type="error" v-show="alert.show">
				<span v-html="alert.message"></span>
			</v-alert>
			<!-- Primary Filters -->
			<registration-report-filter-primary
				style="margin: 25px"
				:appNameShort="appNameShort"
				:selectedMandatorId="selectedMandatorId"
				:disabled="disabledDueNotSelectedMandator || disableButtons"
				:selectedNationalitiesHesta="formState.selectedNationalitiesHesta"
				@emitSelectedValue="changeEmittedValue"
				@emitLoadingVariables="handleLoadingVariables"
				@emitErrorEvent="manageErrorFromFilters"
			/>

			<!-- Secondary Filters -->
			<v-expansion-panels class="secondaryRegistrationReportFilter">
				<v-expansion-panel @change="openCloseCounter += 1" :disabled="disabledDueNotSelectedMandator">
					<v-expansion-panel-header class="secondaryRegistrationReportFilter">
						<template v-slot:default="{ open }">
							<v-row no-gutters>
								<v-col cols="4">
									<strong>{{txt.additonalFilters}}</strong>
								</v-col>
							</v-row>
						</template>
					</v-expansion-panel-header>
					<v-expansion-panel-content class="secondaryRegistrationReportFilter">
						<registration-report-filter-secondary
							:appNameShort="appNameShort"
							:selectedMandatorId="selectedMandatorId"
							:openCloseCounter="openCloseCounter"
							:disabled="disabledDueNotSelectedMandator || disableButtons"
							:selectedNationalitiesIso="formState.selectedNationalitiesIso"
							@emitSelectedValue="changeEmittedValue"
							@emitLoadingVariables="handleLoadingVariables"
							@emitErrorEvent="manageErrorFromFilters"
						/>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
			</v-card>
		</div>
		<v-btn color="primary"
			class="searchButton"
			@click="submitFilters"
			:disabled="disableButtons"
			v-show="showFilters"
			>{{ txt.btn.searchBtn }}
		</v-btn>
		<v-btn
			class="searchButton"
			v-show="!showFilters"
			@click="showFilterHandling"
			>{{ txt.btn.showFilters }}
		</v-btn>
		<v-btn
			class="searchButton"
			:disabled="disableButtons"
			@click="submitExcelExport"
			v-show="!showFilters"
			>{{ txt.btn.excelExportBtn }}
		</v-btn>
	</v-container>
</template>

<script>
import RegistrationReportProgressBar from '../../vueBasics/ProgressCircular.vue'
import RegistrationReportFilterPrimary from './RegistrationReportFilterPrimary.vue'
import RegistrationReportFilterSecondary from './RegistrationReportFilterSecondary.vue'

export default {
	name: 'RegistrationReportFilter',
	components: {
		RegistrationReportProgressBar,
		RegistrationReportFilterPrimary,
		RegistrationReportFilterSecondary,
	},
	props: {
		appNameShort: {
			type: String,
			required: true,
		},
		disableButtons: {
			type: Boolean,
		},
		showFilters: {
			type: Boolean,
		},
	},
	data() {
		return {
			selectedMandatorId: 9999,
			appName: this.appNameShort,
			openCloseCounter: 0,
			formState: {
				selectedFromDate: new Date().toISOString().substr(0, 10),
				selectedTillDate: new Date().toISOString().substr(0, 10),
				selectedMandators: [],
				selectedCountries: [],
				selectedNationalitiesHesta: [],
				selectedNationalitiesIso: [],
				selectedServiceproviders: [],
				selectedTaxexemption: [],
				selectedKantons: [],
				selectedStatus: [],
				selectedServiceproviderCities: [],
				selectedServiceproviderAccommodationType: [],
				selectedResellerPartner: [],
				selectedResellerUser: [],
				selectedArrivalBy: [],
				selectedCheckInDates: [],
				selectedCheckOutDates: [],
			},
			txt: {
				additonalFilters: 'Additional filter options',
				error: {
					generalmessage: 'Error while loading',
					mandator: 'mandators',
					serviceproviders: 'service providers',
					status: 'registration form status',
					hestaNationality: 'HESTA nationality codes',
					isoNationality: 'ISO nationality codes',
					residenceCountry: 'residence country codes',
					kanton: 'cantons',
					arrivalBy: 'arrival methods',
					spCity: 'service provider city',
					spAccommodationType: 'service provider accommodation type',
					resellerPartner: 'reseller partner',
					resellerPartnerUser: 'reseller partner user',
				},
				alert: {
					mandatorEmpty: 'Please select a mandator',
				},
				btn: {
					showFilters: 'Back to search',
					searchBtn: 'Search',
					excelExportBtn: 'Excel Export',
				},
			},
			open: false,
			loadingDataGetServiceProvider: false,
			loadingDataGetServiceProviderCity: false,
			loadingDataGetServiceProviderAccommodationType: false,
			loadingDataGetResellerPartner: false,
			loadingDataGetResellerUser: false,
			loadingDataGetArrivalBy: false,
			loadingDataGetKantons: false,
			loadingDataGetResidenceCountry: false,
			loadingDataGetStatus: false,
			loadingDataGetNationalitiesIso: false,
			loadingDataGetNationalitiesHesta: false,
			alert: {
				show: false,
				message: '',
				type: 'info',
			},
		}
	},
	watch: {
		'formState.selectedMandators': {
			handler() {
				this.selectedMandatorId = this.formState.selectedMandators[0].value
			},
		},
	},
	methods: {
		changeEmittedValue(changeObject) {
			// look up object literals if the syntax is new, I fancy them over switch case
			const valuesToSet = {
				// eslint-disable-next-line max-len
				spAccommodationType: () => { this.formState.selectedServiceproviderAccommodationType = changeObject.values },
				mandator: () => { this.formState.selectedMandators = changeObject.values },
				serviceproviders: () => { this.formState.selectedServiceproviders = changeObject.values },
				fromDate: () => { this.formState.selectedFromDate = changeObject.values },
				tillDate: () => { this.formState.selectedTillDate = changeObject.values },
				fromDates: () => { this.formState.selectedCheckInDates = changeObject.values },
				tillDates: () => { this.formState.selectedCheckOutDates = changeObject.values },
				residenceCountry: () => { this.formState.selectedCountries = changeObject.values },
				spCity: () => { this.formState.selectedServiceproviderCities = changeObject.values },
				resellerPartner: () => { this.formState.selectedResellerPartner = changeObject.values },
				resellerPartnerUser: () => { this.formState.selectedResellerUser = changeObject.values },
				arrivalBy: () => { this.formState.selectedArrivalBy = changeObject.values },
				kanton: () => { this.formState.selectedKantons = changeObject.values },
				status: () => { this.formState.selectedStatus = changeObject.values },
				isoNationality: () => { this.formState.selectedNationalitiesIso = changeObject.values },
				hestaNationality: () => { this.formState.selectedNationalitiesHesta = changeObject.values },
				taxExemption: () => { this.formState.selectedTaxexemption = changeObject.values },
			}
			valuesToSet[changeObject.filterId]()
		},
		handleLoadingVariables(changeObject) {
			const loadingValuesToSet = {
				serviceproviders: () => { this.loadingDataGetServiceProvider = changeObject.value },
				residenceCountry: () => { this.loadingDataGetResidenceCountry = changeObject.value },
				spCity: () => { this.loadingDataGetServiceProviderCity = changeObject.value },
				spAccommodationType: () => { this.loadingDataGetServiceProviderAccommodationType = changeObject.value },
				resellerPartner: () => { this.loadingDataGetResellerPartner = changeObject.value },
				resellerPartnerUser: () => { this.loadingDataGetResellerUser = changeObject.value },
				arrivalBy: () => { this.loadingDataGetArrivalBy = changeObject.value },
				kanton: () => { this.loadingDataGetKantons = changeObject.value },
				status: () => { this.loadingDataGetStatus = changeObject.value },
				isoNationality: () => { this.loadingDataGetNationalitiesIso = changeObject.value },
				hestaNationality: () => { this.loadingDataGetNationalitiesHesta = changeObject.value },
			}
			loadingValuesToSet[changeObject.filterId]()
		},
		manageErrorFromFilters(errorFromFilter) {
			const errorMessageToSet = {
				mandator: () => { this.setError(this.txt.error.mandator) },
				serviceproviders: () => { this.setError(this.txt.error.serviceproviders) },
				status: () => { this.setError(this.txt.error.status) },
				hestaNationality: () => { this.setError(this.txt.error.hestaNationality) },
				isoNationality: () => { this.setError(this.txt.error.isoNationality) },
				residenceCountry: () => { this.setError(this.txt.error.residenceCountry) },
				kanton: () => { this.setError(this.txt.error.kanton) },
				arrivalBy: () => { this.setError(this.txt.error.arrivalBy) },
				spCity: () => { this.setError(this.txt.error.spCity) },
				spAccommodationType: () => { this.setError(this.txt.error.spAccommodationType) },
				resellerPartner: () => { this.setError(this.txt.error.resellerPartner) },
				resellerPartnerUser: () => { this.setError(this.txt.error.resellerPartnerUser) },
			}
			errorMessageToSet[errorFromFilter.filterId]()
		},
		setError(filter) {
			// append to the error message or assign it newly depending if there is some other error shown at the moment
			// eslint-disable-next-line max-len
			if (this.alert.show) this.alert.message += `${this.txt.error.generalmessage}: <strong>${filter}</strong>. <br>`
			else this.alert.message = `${this.txt.error.generalmessage}: <strong>${filter}</strong>. <br>`
			this.alert.show = true
			this.alert.type = 'error'
			// set the loading variables to false, otherwise the ui is blocked by the spinner
			this.loadingDataGetServiceProvider = false
			this.loadingDataGetServiceProviderCity = false
			this.loadingDataGetServiceProviderAccommodationType = false
			this.loadingDataGetResellerPartner = false
			this.loadingDataGetResellerUser = false
			this.loadingDataGetArrivalBy = false
			this.loadingDataGetKantons = false
			this.loadingDataGetResidenceCountry = false
			this.loadingDataGetStatus = false
			this.loadingDataGetNationalitiesIso = false
			this.loadingDataGetNationalitiesHesta = false
			// eslint-disable-next-line no-return-assign
			setTimeout(() => this.alert.show = false, 6000)
		},
		async createFilterObject() {
			const filterData = {
				mandator: this.formState.selectedMandators,
				dateFrom: this.formState.selectedFromDate,
				dateTill: this.formState.selectedTillDate,
				country: this.formState.selectedCountries,
				nationality: this.formState.selectedNationalitiesHesta,
				serviceprovider: this.formState.selectedServiceproviders,
				taxexemption: this.formState.selectedTaxexemption,
				kantons: this.formState.selectedKantons,
				status: this.formState.selectedStatus,
				serviceproviderCity: this.formState.selectedServiceproviderCities,
				serviceproviderAccommodationType: this.formState.selectedServiceproviderAccommodationType,
				resellerPartner: this.formState.selectedResellerPartner,
				resellerUser: this.formState.selectedResellerUser,
				arrivalBy: this.formState.selectedArrivalBy,
				checkInDates: this.formState.selectedCheckInDates,
				checkOutDates: this.formState.selectedCheckOutDates,
				nationalityIso: this.formState.selectedNationalitiesIso,
			}
			return filterData
		},
		async submitFilters() {
			const filterData = await this.createFilterObject()
			if (!this.formState.selectedMandators.length > 0) {
				this.alert.show = true
				this.alert.message = this.txt.alert.mandatorEmpty
				// eslint-disable-next-line no-return-assign
				setTimeout(() => this.alert.show = false, 6000)
			} else {
				this.alert.show = false
				this.selectedFilters = filterData
				this.$emit('submit', filterData)
			}
		},
		async submitExcelExport() {
			const filterData = await this.createFilterObject()
			if (!this.formState.selectedMandators.length > 0) {
				this.alert.show = true
				this.alert.message = this.txt.alert.mandatorEmpty
				// eslint-disable-next-line no-return-assign
				setTimeout(() => this.alert.show = false, 6000)
			} else {
				this.alert.show = false
				this.selectedFilters = filterData
				this.$emit('submitExcelExport', filterData)
			}
		},
		showFilterHandling() {
			this.$emit('filtersShallAppear', true)
		},
	},
	computed: {
		disabledDueNotSelectedMandator() {
			if (this.formState.selectedMandators.length > 0) return false
			return true
		},
	},
}
</script>

<style scoped>
form {
  padding: 60px 60px 0px 30px;
}
.searchButton {
  color: #00a0e3;
  margin-left: 25px;
  margin-top: 25px;
}

v-btn {
  padding-left: 25px;
}

.secondaryRegistrationReportFilter {
	background-color: #ebebeb;
}

</style>
